import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {
  CitizensServicesCategory
} from "../../../../../store/entities/citizens/citizens-services-category/citizens-services-category.model";
import {environment} from "../../../../../../environments/environment";
import {
  CitizensServicesSector
} from "../../../../../store/entities/citizens/citizens-services-sector/citizens-services-sector.model";
import {Institution} from "../../../../../store/entities/system-settings/institution/institution.model";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../../store/reducers";
import {ActivatedRoute} from "@angular/router";
import {
  selectModifiedCitizensServiceCategory
} from "../../../../../store/entities/citizens/citizens-services-category/citizens-services-category.selectors";
import {
  selectModifiedCitizenSector
} from "../../../../../store/entities/citizens/citizens-services-sector/citizens-services-sector.selectors";
import {
  selectModifiedInstitution
} from "../../../../../store/entities/system-settings/institution/institution.selectors";
import {citizenGetServices} from "../../../../../store/entities/citizens/citizens-services/citizens-services.actions";

@Component({
  selector: 'app-all-services',
  templateUrl: './all-services.component.html',
  styleUrl: './all-services.component.scss'
})
export class AllServicesComponent implements OnInit, OnDestroy {
  title: string;
  servicesCategory$: Observable<CitizensServicesCategory []>;
  fileServer: string = environment.FILE_SERVER_URL
  pageHolder: { itemsPerPage: number, pageNumber: number } = {itemsPerPage: 18, pageNumber: 1};
  citizenSectors$: Observable<CitizensServicesSector []>;
  institutions$: Observable<Institution[]>
  routeSub = Subscription.EMPTY;
  keyword: string;
  searchKeyWord: string;
  formValues: any;

  showFilter = true;

  constructor(
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {

    this.servicesCategory$ = this.store.select(selectModifiedCitizensServiceCategory);
    this.citizenSectors$ = this.store.select(selectModifiedCitizenSector);
    this.institutions$ = this.store.select(selectModifiedInstitution);
    this.loadNextData();

  }


  loadNextData() {
    this.store.dispatch(citizenGetServices({
      filtering: {
        ...this.pageHolder,
        ...this.formValues,
        keyword: this.searchKeyWord
      },
      showFew: true
    }));
  }

  paginate(pageable: any) {
    this.pageHolder = {...this.pageHolder, pageNumber: pageable?.pageNumber};
    this.loadNextData();
  }

  onSearch(searchKey: string) {
    this.searchKeyWord = searchKey;
    this.loadNextData();
  }

  onFormData(form) {
    console.log(form);
    this.formValues = form;
    this.loadNextData();
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

}
